import { render } from "./AppEventTemplateEmailEditor.vue?vue&type=template&id=5b7b3b2b"
import script from "./AppEventTemplateEmailEditor.vue?vue&type=script&lang=js"
export * from "./AppEventTemplateEmailEditor.vue?vue&type=script&lang=js"

import "./AppEventTemplateEmailEditor.vue?vue&type=style&index=0&id=5b7b3b2b&lang=css"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__